module.exports = "body {\n  background: url(\"/assets/background2.png\") no-repeat center center;\n  background-size: cover; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main